import { apiFetch } from "../utils/apiFetch";
import React, { useState } from "react";

const StatusChangePopup = ({
  statusChange,
  setStatusChange,
  workspace,
  userId,
  currentUserRole,
}) => {
  const [demoteValue, setDemoteValue] = useState(
    statusChange.value === "owner" ? "admin" : null,
  );

  const changeStatus = async () => {
    try {
      const res = await apiFetch(
        `${process.env.API_URL}/api/${workspace._id}/members/${statusChange.id}/rolechange`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",

          },
          body: JSON.stringify({
            modifierRole: currentUserRole,
            role: statusChange.value,
          }),
        },
      );

      if (!res.ok) {
        throw new Error(res.status + ":" + res.statusText);
      }

      if (!demoteValue) {
        setStatusChange(null);
        return;
      }

      const res1 = await apiFetch(
        `${process.env.API_URL}/api/${workspace._id}/members/${userId}/rolechange`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",

          },
          body: JSON.stringify({
            modifierRole: currentUserRole,
            role: demoteValue,
          }),
        },
      );

      if (!res1.ok) {
        throw new Error(res1.status + ":" + res1.statusText);
      }

      setStatusChange(null);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="w-[40dvw] h-[35dvh] bg-white rounded-lg p-6">
        {statusChange.value === "owner" && (
          <>
            <p className="text-gray-900 text-sm">
              By making {statusChange.username} an owner of this group you
              will be demoted to either Admin or Member as groups can have
              only one owner.
            </p>

            <div className="flex my-5">
              <span className="text-gray-900 text-sm">
                You will be demoted to{" "}
              </span>
              <select
                className="ml-2 bg-gray-100 text-gray-800 border-gray-500 inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-secondary/90"
                onChange={(e) => setDemoteValue(e.target.value)}
                value={demoteValue}
              >
                <option value={"admin"}>Admin</option>
                <option value={"member"}>Member</option>
              </select>
            </div>
          </>
        )}

        {String(statusChange.id) === String(userId) &&
        currentUserRole === "owner" ? (
          <p className="text-gray-900 text-sm">
            Owners cannot change to other roles unless they make someone else an
            Owner
          </p>
        ) : (
          <>
            <div className="text-gray-900 text-sm">
              {String(statusChange.id) !== String(userId)
                ? `Are you sure you want to change status of ${statusChange.username} to
          ${statusChange.value}?`
                : `Are you sure you want to change your role to ${statusChange.value}?`}
            </div>
            <div className="flex justify-end">
              <button
                onClick={() => setStatusChange(null)}
                className="mx-2 border p-2"
              >
                Cancel
              </button>
              <button
                onClick={async () => {
                  changeStatus();
                }}
                className="mx-2 border p-2"
              >
                Yes
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default StatusChangePopup;
